import { addFirePrefix } from '@chilipiper/admin-center-common'

/*
 * todo: once we have backend ready we should discuss how we should set up the routes and what
 * needs to be passed around in route (eg. meetingTypeId) as (as far as I'm aware) with Chilical
 * we will only make changes to personal templates. Given that, the URLs will be a bit different
 * I suppose than what we currently have in homebase
 * */

const meetingTypeRoute = (meetingTypeId?: string) => {
  return addFirePrefix(`/meeting-types/${meetingTypeId}`)
}

export const meetingTypesRoutes = {
  meetingTypes: () => addFirePrefix('/meeting-types'),
  openMeetingType: (meetingTypeId = ':meetingTypeId') => `${meetingTypeRoute(meetingTypeId)}`,
  openAdvancedSettings: (meetingTypeId = ':meetingTypeId') =>
    `${meetingTypeRoute(meetingTypeId)}/advanced-settings`,
  openMeetingBuffer: (meetingTypeId = ':meetingTypeId') =>
    `${meetingTypeRoute(meetingTypeId)}/meeting-buffer`,
  openGuestForm: (meetingTypeId = ':meetingTypeId') =>
    `${meetingTypeRoute(meetingTypeId)}/guest-form`,
  openAvailability: (meetingTypeId = ':meetingTypeId') =>
    `${meetingTypeRoute(meetingTypeId)}/availability`,
  openMeetingInvite: (meetingTypeId = ':meetingTypeId') =>
    `${meetingTypeRoute(meetingTypeId)}/meeting-invite`,
  openMeetingReminders: (meetingTypeId = ':meetingTypeId') => ({
    index: `${meetingTypeRoute(meetingTypeId)}/reminders`,
    create: `${meetingTypeRoute(meetingTypeId)}/reminders/create/:reminderType`,
    edit: `${meetingTypeRoute(meetingTypeId)}/reminders/:reminderId/edit`,
  }),
}

export const routes = {
  index: addFirePrefix('/'),
  home: {
    index: addFirePrefix('/home'),
    calendar: addFirePrefix('/calendar'),
  },
  meetingReports: {
    index: addFirePrefix('/meeting-reports'),
    detail: (meetingId = ':meetingId') => addFirePrefix(`/meeting-reports/${meetingId}`),
  },
  signup: addFirePrefix('/signup'),
  extensionLogin: addFirePrefix('/extension-login'),
  emailAgentReview: addFirePrefix('/email-agent/reviews'),
  inbox: addFirePrefix('/inbox'),
  gtmo: {
    index: addFirePrefix('/gtmo'),
    board: addFirePrefix('/gtmo/board'),
    health: addFirePrefix('/gtmo/health'),
    company: (companyId = ':companyId') => addFirePrefix(`/gtmo/company/${companyId}`),
  },
  meetingTypeList: meetingTypesRoutes.meetingTypes(),
  meetingType: {
    index: meetingTypesRoutes.openMeetingType(),
    advancedSettings: meetingTypesRoutes.openAdvancedSettings(),
    bookingPage: '',
    meetingInvite: meetingTypesRoutes.openMeetingInvite(),
    availability: meetingTypesRoutes.openAvailability(),
    guestForm: meetingTypesRoutes.openGuestForm(),
    meetingBuffer: meetingTypesRoutes.openMeetingBuffer(),
  },
  availability: {
    index: addFirePrefix('/availability'),
    custom: addFirePrefix('/availability/custom'),
    customEdit: (id = ':availabilityId') => addFirePrefix(`/availability/custom/${id}`),
  },
  personalPage: addFirePrefix('/personal-page'),
  reminder: {
    index: meetingTypesRoutes.openMeetingReminders().index,
    create: meetingTypesRoutes.openMeetingReminders().create,
    edit: meetingTypesRoutes.openMeetingReminders().edit,
  },
  integrations: addFirePrefix('/integrations'),
  personalSettings: {
    index: addFirePrefix('/personal-settings'),
    personalDetails: addFirePrefix('/personal-settings/personal-details'),
  },
  onboarding: {
    index: addFirePrefix('/onboarding'),
    workingHours: addFirePrefix('/onboarding/working-hours'),
    location: addFirePrefix('/onboarding/location'),
    extension: addFirePrefix('/onboarding/extension'),
    requestLicenses: addFirePrefix('/onboarding/request-licenses'),
  },
}
